import React from 'react'

// Styles
import Style from "./LoaderElement.module.css";

const LoaderElement = () => {
    return (
        <div className={Style.spinner}>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    )
}

export default LoaderElement